import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";
import generatedFormatDate from "utils/generatedDate";

export const COLUMNS_DATA = ({
  deleteRow,
  editRow,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Doctor Name",
    accessor: "doctor_obj.doctor_name",
    disableSortBy: true,
  },
  {
    Header: "Reg No",
    accessor: "patient_obj.registration_no",
    disableSortBy: true,
  },
  {
    Header: "Patient",
    accessor: "patient_obj.patient_name",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "generated",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Gross Amount",
    accessor: "gross_amount",
    disableSortBy: true,
  },
  {
    Header: "Net Amount",
    accessor: "net_amount",
    disableSortBy: true,
  },
  {
    Header: "Discount Amount",
    accessor: "discount_amount",
    disableSortBy: true,
  },
  {
    Header: "Bill Item",
    accessor: "bill_item",
    disableSortBy: true,
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
];

export const DETAILS_COLUMNS = ({
  deleteRow,
  editRow,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Doctor Name",
    accessor: "doctor_obj.doctor_name",
    disableSortBy: true,
  },
  {
    Header: "Reg No",
    accessor: "patient_obj.registration_no",
    disableSortBy: true,
  },
  {
    Header: "Patient",
    accessor: "patient_obj.patient_name",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "generated",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
  {
    Header: "Gross Amount",
    accessor: "gross_amount",
    disableSortBy: true,
  },
  {
    Header: "Net Amount",
    accessor: "net_amount",
    disableSortBy: true,
  },
  {
    Header: "Discount Amount",
    accessor: "discount_amount",
    disableSortBy: true,
  },
  {
    Header: "Bill Item",
    accessor: "bill_item",
    disableSortBy: true,
  },
];

export const DOCTOR_OPD_BILL_ITEM_FORM_CONFIG = (rowData) => [
  {
    label: "Doctor",
    type: "select",
    name: "refer_doctor_name",
    defaultValue: rowData?.doctor_id || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Clinic",
    type: "select",
    name: "clinic_id",
    defaultValue: rowData?.clinic_id || "",
    validations: {
      required: true,
    },
  },
  {
    label: "Bill Item",
    type: "select",
    name: "bill_item",
    defaultValue: rowData?.bill_item || "",
    validations: {
      required: true,
    },
    options: [
      { label: "Consultation", value: "CONSULTATION" },
      { label: "Follow Up", value: "FOLLOW_UP" },
      { label: "Procedure", value: "PROCEDURE" },
      { label: "Emergency", value: "EMERGENCY" },
    ],
  },
  {
    label: "Gross Amount",
    type: "input-number",
    name: "gross_amount",
    defaultValue: rowData?.gross_amount || "",
    validations: {
      required: true,
      min: 0,
    },
  },
  {
    label: "Discount Amount",
    type: "input-number",
    name: "discount_amount",
    defaultValue: rowData?.discount_amount || 0,
    validations: {
      min: 0,
    },
  },
  {
    label: "Tax Amount",
    type: "input-number",
    name: "tax_amount",
    defaultValue: rowData?.tax_amount || 0,
    validations: {
      min: 0,
    },
  },
  {
    label: "Net Amount",
    type: "input-number",
    name: "net_amount",
    defaultValue: rowData?.net_amount || "",
    validations: {
      required: true,
      min: 0,
    },
  },
];

export const OPTIONS = [
  { key: "clinic_name", value: "Clinic Name" },
  { key: "clinic_address", value: "Clinic Address" },
];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
